const hostname = window.location.hostname
let domain = 'http://localhost:8082'

if (hostname.indexOf('localhost') > -1) {
	domain = 'http://localhost:8082'
} else if (hostname.indexOf('app.readpeak.com') > -1) {
	domain = 'https://api.readpeak.com'
} else if (hostname.indexOf('staging.readpeak.com') > -1) {
	domain = 'https://api-staging.readpeak.com'
} else if (hostname.indexOf('.readpeak.net') > -1) {
	domain = 'https://api.staging.readpeak.net'
}

let jwt = ''
export const initFetch = (token: string) => {
	jwt = token
}

export const getApiHost = () => {
	return domain
}

export enum ApiStatus {
	OK = 'OK',
	ERROR = 'error',
}

export interface ApiResponse<T> {
	status: ApiStatus
	data?: T
	message?: string
}

const defaultHeader = {
	'Content-Type': 'application/json',
}

const apiFetch = (
	input: RequestInfo,
	init?: RequestInit | undefined,
	defaultHeaders: Record<string, string> = defaultHeader,
) => {
	if (typeof input === 'string') {
		input = `${domain}${input}`
	}

	const headers = {
		Authorization: `Bearer ${jwt}`,
		Accept: 'application/json',
		...defaultHeaders,
		...(init?.headers || {}),
	}

	init = {
		...init,
		headers,
	}

	return fetch(input, init)
}

export default apiFetch
